// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--2rpIK","Item":"Item--_t2Wg","Tag":"Tag--3iyfM"};